/**
 * Get the best video URL for playback — DLC labeled version if available, otherwise original.
 * Only use labeled URL when explicitly stored in notes (confirmed uploaded).
 */
export function getLabeledVideoUrl(video) {
  // Check notes field for confirmed DLC labeled URL
  if (video.notes) {
    const match = video.notes.match(/(https:\/\/[^\s]+dlc_labeled\.\w+)/);
    if (match) return match[1];
  }

  // Fall back to original video
  return video.file_url;
}
